module.exports = __webpack_public_path__ + "static/media/Machoke_gaussian2.17997d70.png";